import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { Box, Divider, Typography } from "@mui/material";
import ApmLink from "@shared/ApmLink";
import { Modal } from "@shared/Modal/Modal";

const useStyles = makeStyles()((theme) => ({
    row: {
        display: "flex",
        padding: theme.spacing(2, 0),
        gap: theme.spacing(4),
    },
    logoBox: {
        width: 120,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(1),
        flexShrink: 0,
    },
    listBox: {
        flex: 1,
        minWidth: 0,
    },
    li: { marginBottom: theme.spacing(1), display: "flex", alignItems: "center", gap: theme.spacing(1), flexWrap: "wrap" },
}));

type Props = {
    open: boolean;
    onClose: () => void;
};

export const LegacyInstallersDialog = ({ open, onClose }: Props) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages", "modals", "common"]);

    if (!open) {
        return null;
    }

    const installers = [
        {
            id: "linux",
            iconClass: "fa-brands fa-3x fa-linux",
            title: t("pages:downloadsPage.installer.linux.title"),
            version: t("pages:downloadsPage.installer.linux.version"),
            size: t("pages:downloadsPage.installer.linux.size"),
            fileName: "Emteria.OS_Installer-v1.1-43.AppImage",
            href: "https://s3.emteria.com/public/installer/Emteria.OS_Installer-v1.1-43.AppImage",
        },
        {
            id: "windows",
            iconClass: "fa-brands fa-3x fa-windows",
            title: t("pages:downloadsPage.installer.windows.title"),
            version: t("pages:downloadsPage.installer.windows.version"),
            size: t("pages:downloadsPage.installer.windows.size"),
            fileName: "Emteria.OS_Installer-v1.1-43.exe",
            href: "https://s3.emteria.com/public/installer/Emteria.OS_Installer-v1.1-43.exe",
        },
    ];

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t("modals:legacyInstallers.title")}
            description={t("modals:legacyInstallers.description")}
        >
            {installers.map((installer, index) => (
                <React.Fragment key={installer.id}>
                    {index > 0 ? <Divider /> : null}
                    <Box className={classes.row}>
                        <Box className={classes.logoBox}>
                            <i className={installer.iconClass} />
                            <Typography variant="subtitle1">{installer.title}</Typography>
                        </Box>
                        <Box className={classes.listBox}>
                            <ul>
                                <li className={classes.li}>
                                    <Typography>{installer.version}</Typography>
                                </li>
                                <li className={classes.li}>
                                    <Typography>{installer.size}</Typography>
                                </li>
                                <li className={classes.li}>
                                    <Typography>{t("pages:downloadsPage.installer.download")}</Typography>
                                    <ApmLink parent="Downloads page" title={t("common:button.download")} href={installer.href}>
                                        <Typography>{installer.fileName}</Typography>
                                    </ApmLink>
                                </li>
                            </ul>
                        </Box>
                    </Box>
                </React.Fragment>
            ))}
        </Modal>
    );
};
